// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"ii","logoWrapper":"ij"};